<template>
    <!-- v-loading="loadingMydevice" -->
    <div class="adminHome tableloding">
      <account-nav v-if="showSidebar" @noticeDeviceBox="showDeviceBox"></account-nav>
      <component class="article" :is="shownComponent" v-if="shownComponent" @noticeDeviceBox="showDeviceBox"></component>
    </div>
  </template>
  <script>
  // import deviceNav from './sidebar'
  // import deviceOverview from './device'
  // import deviceDetail from './singleBox/deviceindex'
  // import deviceNo from './deviceno'
  import accountNav from './accoutTreeBar'
  import account from "./account"
  // import group from "./group"
  import singleBox from "./singleBox"
  
  import { mapGetters } from 'vuex'
  // import deviceDialog from "@/components/dialognew";
  export default {
    components: {
      accountNav,
      account,
      singleBox,
      // deviceOverview,
      // deviceDetail,
      // deviceNo,
      // deviceDialog
    },
    data () {
      return {
        // null: deviceOverview: 设备概览、 deviceDetail: 设备单个
        shownComponent: 'account',
        // 设备列表
        deviceList: [],
        // 添加成功提示弹窗
        dataloggerAddSucVisible: false,
        // 显示侧边栏
        showSidebar: true,
        // Loading
        loadingMydevice: false,
        // 切换列表和单个
        showTabel: true,
        // 接收侧栏点击传递的分组ID
        // changeGroupId: '',
      }
    },
    computed: {
      ...mapGetters({
        deviceInfo: 'getDeviceInfo'
      }),
    },
    watch: {
      showTabel: {
        handler (val) {
          // console.log('watch-showTabel', val);
          if (!val) { // 详情
            this.showSidebar = true
            this.shownComponent = 'singleBox'
          } else { // 概览
            this.showSidebar = true
            this.shownComponent = 'account'
          }
        },
        deep: true
      },
      // changeGroupId: {
      //   handler (val) {
      //     console.log('watch-changeGroupId', val);
      //     if(!val) { // 详情
      //       this.showSidebar = true
      //       this.shownComponent = 'singleBox'
      //     } else { // 概览
      //       this.showSidebar = true
      //       this.shownComponent = 'account'
      //     }
      //   },
      //   deep: true
      // },
      // deviceInfo: {
      //   handler (val) {
      //     // console.log('deviceInfo', val)
      //     if(val.pn) {
      //       this.showSidebar = true
      //       this.shownComponent = 'deviceDetail'
      //     } else {
      //       this.showSidebar = false
      //       // this.shownComponent = 'deviceOverview'
      //       // 空设备
      //       // this.shownComponent = 'deviceNo'
      //       this.$router.push({path:'/generalNew/deviceno'})
      //     }
      //   },
      //   deep: true
      // },
      // 响应更新电站列表事件
      '$store.state.event.updateDeviceList' (val) {
        if (val) {
          this.queryDeviceList(true)
          this.$store.state.event.updateDeviceList = false
        }
      }
    },
    created () {
      this.queryDeviceList()
      // 数采器管理页添加数采器回我的设备页通知
      if (this.$route.query.tool) {
        this.isNotice = this.$route.query.tool.notice;
      }
      if (this.isNotice == 'Suc') {
        // console.log('我的设备页=>添加成功回调');
        // 通知数采器列表更新
        this.$store.state.event.updateDataloggerList = true;
        window.location.href = this.delurlquery(window.location.href, "tool");
        // window.location.reload();
        setTimeout(() => {
          this.handleCreateSuc();
        }, 0)
      }
    },
    beforeDestroy () {
      this.$store.commit('saveDeviceInfo', {
        sn: null,
        deviceSn: null
      })
    },
    methods: {
      // 接收侧栏点击传递的分组ID
      // receiveGroupId(val){
      //   console.log("receive-group", val);
      //   this.changeGroupId = val;
      // },
      // 辅助传参=删url指定query
      delurlquery (url, key) {
        key = this.escapereg(key);
        var reg = new RegExp("((\\?)(" + key + "=[^&]*&)+(?!" + key + "=))|(((\\?|&)" + key + "=[^&]*)+$)|(&" + key + "=[^&]*)", "g");
        return url.replace(reg, "\x241")
      },
      // 辅助传参=拼正则表达式字符串时消除原字符串中特殊字符干扰
      escapereg (str) {
        // eslint-disable-next-line no-useless-escape
        return str.replace(new RegExp("([.*+?^=!:\x24{}()|[\\]\/\\\\])", "g"), "\\\x241");
      },
      // 添加数采器成功回调
      handleCreateSuc () {
        this.dataloggerAddSucVisible = true;
        // 通知数采器列表更新
        this.$store.state.event.updateDataloggerList = true;
      },
      // 查询用户设备列表
      queryDeviceList (noRefresh) {
        let param = {
          devtype: 2304,
          pageSize: 500
        }
        this.loadingMydevice = true;
        this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
          // res.data.items可能为null/非数组，且无设备时不走有数据分支
          if (res.code == 0 && Array.isArray(res.data && res.data.items) && res.data.items.length > 0) {
            this.deviceList = this.Fnreturndev(res)
            let devcode = this.$route.query.devcode,
              pn = this.$route.query.pn,
              devaddr = this.$route.query.devaddr,
              sn = this.$route.query.sn,
              // 增
              usr = this.$route.query.usr,
              // 增
              uid = this.$route.query.uid;
  
            let selectedDevice = this.deviceList.find(item => {
              return item.devcode == devcode &&
                item.pn == pn &&
                item.devaddr == devaddr &&
                item.sn == sn &&
                // 增
                item.usr == usr &&
                // 增
                item.uid == uid
            })
            if (!noRefresh) {
              if (sn && selectedDevice) {
                // Loading 
                this.loadingMydevice = false;
                this.$store.commit('saveDeviceInfo', { ...selectedDevice, deviceSn: selectedDevice.deviceSn || selectedDevice.sn })
                return
              } else if (this.deviceList.length) {
                // Loading
                this.loadingMydevice = false;
                this.$store.commit('saveDeviceInfo', { ...this.deviceList[0], deviceSn: this.deviceList[0].deviceSn || this.deviceList[0].sn })
                return
              }
            }
          }
          // console.log("account-indexnew-saveEmpty");
          this.$store.commit('saveDeviceInfo', { pn: '', sn: '', deviceSn: '', devcode: '', devaddr: '', usr: '', uid: '' });
          // this.loadingMydevice = false;
        })
      },
      // 响应显示设备信息页
      showDeviceBox (val) {
        // console.log('methods-showTabel', val);
        this.showTabel = val;
      },
    }
  }
  </script>
  <style lang="less" scoped>
  .adminHome {
    width: calc(100% - 304px);
    margin: 20px;
    flex: 1;
    display: flex;
    align-items: stretch;
    background: rgba(45, 63, 75, 1);
  
    .article {
      display: flex;
      flex: 1;
      overflow: hidden;
    }
  
    &.tableloding {
  
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }
  
      // .el-loading-spinner i {
      //   color: @primaryTextColor;
      // }
      /deep/.el-loading-spinner .path {
        stroke: @primaryTextColor;
      }
    }
  }
  
  // #操作结果提示#
  .showresultbox {
    display: flex;
    flex-direction: column;
    align-items: center;
  
    // 图标
    .showsuccess {
      border: 3px solid rgba(37, 255, 174, 1);
      background-color: rgba(19, 195, 156, 1);
      background-image: url(../../../assets/img/general/Icon_Finished.png);
      background-size: 70px 70px;
    }
  
    .showfail {
      border: 3px solid rgba(246, 189, 189, 1);
      background: rgba(251, 75, 75, 1);
      background-image: url(../../../assets/img/general/Icon_Failed.png);
      background-size: 120px 120px;
    }
  
    .showbase {
      width: 100px;
      height: 100px;
      box-sizing: border-box;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 50%;
    }
  
    // 提示
    .showresulttext {
      font-weight: bold;
      font-size: 18px;
      margin-top: 20px;
      margin-bottom: 30px;
      color: rgba(255, 255, 255, 1);
    }
  
    // 操作
    .showoperate {
      text-align: center;
    }
  
    .showresultbtn {
      width: 102px;
      height: 30px;
      margin-top: 10px;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      font-size: 14px;
    }
  }
  </style>
  